import React from 'react'
import { Popover, Button, Space, Typography, Divider } from 'antd'
import { useNavigate } from 'react-router-dom'
import { User, LogOut } from 'lucide-react'
import { useCompanyStore } from '../../store/company/companyStore'
import { useApi } from '../../services/ApiContext'
import { TrialBanner } from './AppNav'
const { Text } = Typography

export const UserPopover: React.FC = () => {
  const { company, user } = useCompanyStore()
  const { logout } = useApi()

  const navigate = useNavigate()

  if (!user || user?.isDemo) {
    navigate('/signup')
    return (
      <></>
    )
  }

  const handleLogout = async () => {
    await logout()
    navigate('/login')
  }

  const content = (
    <div className="w-[300px]">
      <div className="px-4 py-3">
        <Text strong className="block">
          {user.firstName} {user.lastName}
        </Text>
        <Text type="secondary" className="block">
          {user.email}
        </Text>
        <Text className="block mt-1">{company.name}</Text>
      </div>

      <Divider className="my-2" />

      <div className="px-2">
        <Space direction="vertical" className="w-full">
          {/* <Button
            type="text"
            icon={<Settings className="h-4 w-4" />}
            onClick={() => navigate('/app/settings')}
            block
          >
            Account Settings
          </Button> */}

          {/* <Button
            type="text"
            icon={<CreditCard className="h-4 w-4" />}
            onClick={() => navigate('/pricing')}
            block
          >
            Plans & Billing
          </Button> */}

          <Button
            type="text"
            icon={<LogOut className="h-4 w-4" />}
            onClick={handleLogout}
            danger
            block
          >
            Sign Out
          </Button>
        </Space>
      </div>

      {/* {user.plan && (
        <>
          <Divider className="my-2" />
          <div className="px-4 py-2">
            <Text type="secondary" className="text-sm block">
              Current Plan: <Text strong>{user.plan}</Text>
            </Text>
          </div>
        </>
      )} */}
    </div>
  )

  return (
    <div className="flex gap-2">
      <Popover content={content} trigger="click" placement="bottomRight">
        <Button
          type="text"
          icon={<User className="h-4 w-4" />}
          className="flex items-center gap-2"
        >
          <span className="hidden sm:inline">
            {user.firstName} {user.lastName}
          </span>
        </Button>
      </Popover>
      <TrialBanner />
    </div>
  )
}
